/* eslint @typescript-eslint/no-empty-function: 0 */
/* eslint react/no-array-index-key: 0 */
/* eslint react/no-unused-prop-types: 0 */
import React from 'react'

import NoOrderSelectedSvg from '../../../assets/svg/no-order-selected.svg'
import Navbar, { NavItemProps } from '../../../components/navbar'
import { If } from '../../../components/if/if'
import Icon from '../../../components/icon'
import CustomerDetails from './customer-details'
import OrderDetails from './order-details'
import {
  Container,
  Sidebar,
  HeaderSidebar,
  TitleWrapper,
  Search,
  OrdersWrapper,
  ContentWrapper,
  NoContentWrapper,
} from './styles'
import OrderCard from './order-card'
import { OrderStatus } from '../../../enums/order.enum'
import CustomerQuantityModal from './customer-quantity-modal'
import { useOrder } from '../../../contexts/order'

type SearchProps = {
  filters: string[];
}

type Props = {
  selectedFilter: string | null;
  setSelectedFilter: (value: string | null) => void;
  setSearch: (value: string) => void,
  search: string,
  searchOptions: SearchProps;
  orders: any;
  navbarItems: NavItemProps[];
  currentPageId: number;
  handlePaidTheBill: () => void;
}

const Orders = ({
  search,
  setSearch,
  setSelectedFilter,
  searchOptions,
  orders,
  currentPageId,
  navbarItems,
}: Props) => {
  const {
    orderPad: currentOrderPad,
    setOrderPadId,
    setCurrentOrderPadCard,
  } = useOrder()

  return (
    <Container>
      <Sidebar>
        <HeaderSidebar>
          <div>
            <TitleWrapper>
              <h1>Pedidos</h1>
              <span>{orders.length}</span>
            </TitleWrapper>
            <select
              onChange={(e) => {
                const { value } = e.target
                const status: any = {
                  Todos: null,
                  'Em aberto': '0',
                  'Aguardando pagamento': '1',
                  'Mesa vazia': '2',
                }

                setSelectedFilter(status[value])
              }}
            >
              {
                searchOptions.filters.map((filter, idx: number) => (
                  <option
                    key={idx}
                  >
                    {filter}
                  </option>
                ))
              }
            </select>
          </div>

          <Search>
            <Icon name="search" />
            <input type="text" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar pedido/mesa" />
          </Search>
        </HeaderSidebar>

        <OrdersWrapper>
          {
            orders.map((order: any) => (
              <OrderCard
                key={order.id}
                order={order}
                isSelected={currentOrderPad?.id === order.id}
                onClick={
                  order.status !== OrderStatus.WITHOUT_ORDER || order.status === null
                    ? () => {
                      setOrderPadId(order.orderPadId)
                      setCurrentOrderPadCard(order)
                    }
                    : () => { }
                }
              />
            ))
          }
        </OrdersWrapper>
      </Sidebar>

      <If condition={currentOrderPad}>
        <ContentWrapper>
          <Navbar
            items={navbarItems}
            selectedItemId={currentPageId}
          />

          <If condition={currentPageId === 0}>
            <OrderDetails />
          </If>

          <If condition={currentPageId === 1}>
            <CustomerDetails />
          </If>

        </ContentWrapper>
      </If>

      <If condition={!currentOrderPad}>
        <NoContentWrapper>
          <img src={NoOrderSelectedSvg} alt="Nenhum pedido selecionado" />
          <h4>Acompanhe todos os pedidos</h4>
          <p>Clique em um pedido na lateral para ver os detalhes da cada pedido</p>
        </NoContentWrapper>
      </If>

      <CustomerQuantityModal />
    </Container>
  )
}

export default Orders
